// extracted by mini-css-extract-plugin
export default {"container":"uVUBSZMI2irotegPeI1g","leaderboardTitle":"t03wYRdbq4691TQQRWue","leaderboardTable":"erjU8cpzNLXdmd1JN93V","leaderboardTableScrollBar":"rAQhpIOHMyPeefX9xOe1"};